import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

export var TestListRes;
export const TestListTodo = createAsyncThunk('TestList', async (data) => {


    try {
        const res = await axios({
            method: "get",
            url: process.env.REACT_APP_API_URL + 'admin/test',
            params: {
                "company_id": localStorage.getItem('companyId')
            },
            headers: { "Content-Type": "application/json", "Authorization": 'Bearer ' + localStorage.getItem('user_token') },

        })
        return TestListRes = res.data

    } catch (error) {
        return TestListRes = error.response.data
    }
});

const TestListSlice = createSlice({
    name: 'TestList',
    initialState: {
        data: null,
    },
    extraReducers: (builder) => {
        builder.addCase(TestListTodo.fulfilled, (state, action) => {
            state.data = action.payload;
            // console.log('userList', state.data)
        });
        builder.addCase(TestListTodo.rejected, (state, action) => {
            // console.log('token_error', action)
        })
    }
});

export default TestListSlice.reducer; 